<template>
  <el-dialog
    title="查看通知"
    :visible.sync="dialogVisible"
    width="800px"
    center
    >
    <div class="box">
      <h3>{{ details.title }}</h3>
      <p>
        <i class="el-icon-date"></i>
        <span>{{ details.publish_time }}</span>
        <i class="el-icon-user"></i>
        <span>{{ details.created_user }}</span>
        
        <span style="margin-left: 30px;">发布范围：</span>
        <span>{{ details.notice_scope }}</span>
      </p>
      
      <div v-html="details.content"></div>
      <div v-if="details.attach && details.attach.length" style="margin-top: 30px;">
        <div class="flex-fs" v-for="(item,i) in details.attach" :key="i" style="margin-bottom: 7px;">
          <span>附件{{ i+1 }}：</span>
          <el-link type="primary" :href="item" download target="_blank">{{ item | fileName }}</el-link>
        </div>
        
      </div>
    </div>
    
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  import { publish_type, user_type } from  '@/filters'
  import { upload } from '@/api/upload';
  export default {
    data() {
      return {
        dialogVisible: false,
        details: ''
      }
    },
    methods: {
      show(row){
        userInfoAPI.detailNotice(row.id).then(({ data })=>{
          if (data.code == 0) {
            if(typeof data.data.attach == 'string') data.data.attach = JSON.parse(data.data.attach) 
            if(data.data.notice_scope){
              let map = new Map();
              data.data.notice_scope = data.data.notice_scope.filter(item => !map.has(item['user_type']) && map.set(item['user_type'],1))
              data.data.notice_scope = data.data.notice_scope.map(i=>{
                return user_type(i.user_type)
              }).join('、')
            }
            this.details = data.data
            this.dialogVisible = true
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  h3,p{
    // text-align: center;
  }
  p{
    margin: 20px 0;
  }
  .el-icon-date,.el-icon-user{
    margin-right: 10px;
    font-size: 16px;
  }
  .el-icon-user{
    margin-left: 30px;
  }
  .type{
    &::after{
      content: '、';
    }
    &:nth-last-child(1)::after{
      content: ''
    }
  }
</style>